import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart-icon",
  "use": "heart-icon-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" id=\"heart-icon\">\n  <path d=\"M17 5.97628C17 10.4328 9 15 9 15C9 15 1 10.4328 1 5.97628C0.999989 0.0869237 8.11111 -0.715323 9 4.32204C9.88889 -0.715321 17 0.0869237 17 5.97628Z\" stroke=\"currentColor\" fill=\"none\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol